<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

function ctmItemClickCall(value) {
  const correspondingCheckbox = document.querySelector(
    `.facets .facets__label .facet-checkboxs .cate-list .list-menu__item input[value="${value}"]`
  );
  console.log(correspondingCheckbox);
  correspondingCheckbox.click();
}


function cateClickCall(value) {
    const correspondingCheckbox = document.querySelector(`.facets .facets__label .facet-checkboxs .cate-list .checkbox-control input[value="${value}"]`);
        correspondingCheckbox.click();
}

const smoothScroll = (to, d = 800) => {
    const s = window.scrollY, t = performance.now();
    requestAnimationFrame(function a(n) {
      const p = Math.min((n - t) / d, 1);
      window.scrollTo(0, s + (to - s) * p);
      p < 1 && requestAnimationFrame(a);
    });
};

  document.addEventListener('click', e => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;

    const t = document.querySelector(a.getAttribute('href'));
    if (!t) return;

    e.preventDefault();
    smoothScroll(t.offsetTop, 800);
  });


  // ------------ctm-faq-------------
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.classList.toggle('active');
    });
  });
});


// ------------store-locator-------------
document.addEventListener("DOMContentLoaded", function () {
  var offcanvasMenu = document.querySelector(".offcanvas-menu");

  document.querySelectorAll(".menu-click").forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.stopPropagation(); // Stop propagation to prevent the body click event from triggering
      offcanvasMenu.classList.toggle("open");
      toggleBodyOverflow();
    });
  });

  document.body.addEventListener("swipeleft", function () {
    offcanvasMenu.classList.add("open");
    toggleBodyOverflow();
  });

  document
    .querySelector(".offcanvas-menu")
    .addEventListener("swiperight", function () {
      offcanvasMenu.classList.toggle("open");
      toggleBodyOverflow();
    });

  document.body.addEventListener("click", function (event) {
    const offcanvasMenus = document.querySelectorAll(".offcanvas-menu");

    offcanvasMenus.forEach((offcanvasMenu) => {
      if (
        !offcanvasMenu.contains(event.target) &&
        !event.target.closest(".offcanvas-menu")
      ) {
        if (!offcanvasMenu.classList.contains("open")) {
          return;
        }

        offcanvasMenu.classList.remove("open");
        toggleBodyOverflow();
      }
    });
  });

  function toggleBodyOverflow() {
    document.body.classList.toggle("overflow-hidden");
  }
});



